import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class CalendarioService {
  baseUrl = environment.API_URL;

  constructor(public http: HttpClient) { }

  getCalendarEventList() {
    return this.http.get<any>(this.baseUrl + '/calendario-api/get-calendar-event-list');
  }
}
